import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NetworkStatusService {
  private isOnlineSubject = new BehaviorSubject<boolean>(navigator.onLine);

  constructor() {
    // Listen for online/offline events
    window.addEventListener('online', () => this.updateOnlineStatus(true));
    window.addEventListener('offline', () => this.updateOnlineStatus(false));
  }

  private updateOnlineStatus(isOnline: boolean) {
    this.isOnlineSubject.next(isOnline);
  }

  get isOnline$() {
    return this.isOnlineSubject.asObservable();
  }

  get isOnline() {
    return this.isOnlineSubject.getValue();
  }
}